// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
    // Ce paramètre est à utiliser lors des appels à l'API Local Storage (stockage
    // d'informations côté client), afin d'avoir des clés liées au nom de l'application.
    // Ceci permet à la fois d'éviter des conflits avec d'autres applications, et
    // de faciliter la réutilisation de code (par exemple, les services d'authentification
    // s'appuient sur cette propriété)
    nomApplication: 'aav-web',
    enquete: 'sur l\'activité des Associations d\'Aide aux Victimes durant l\'année',
    enqueteRaccourci: 'sur l\'activité des AAV durant l\'année',
    // Conditionne l'activation du mode "production" d'Angular (up les performances)
    // Ne peut être externalisé, car utilisé AVANT démarrage de l'application Angular.
    production: false,
    // Permet de faire apparaitre des outils supplémentaires lors du développement
    recette: true,
    // Permet de savoir si l’on est en développement pur ou en recette
    dev: false,
    // URL vers les web services
    apiUrl: '${API_URL}',
    // apiUrl: 'http://10.21.2.237:32000',

    // URL vers les web services d'authentification
    authUrl: '${AUTH_URL}',
    // client OIDC
    clientId: '${CLIENT_ID}',
    // authUrl: 'https://authv6.sdse.intranet.justice.gouv.fr/api',
    version: '${VERSION}',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error'; // Included with Angular CLI.

